<script setup lang="ts">
    import type { AiMessage } from '~/stores/aiAssistantTypes';

    defineProps<{
        message: AiMessage;
    }>();

    const emit = defineEmits<{
        (e: 'option-selected', value: string): void;
    }>();

    const selectOption = (value: string, optionSelected?: boolean) => {
        if (optionSelected) return;
        emit('option-selected', value);
    };
</script>

<template>
    <div class="flex flex-row gap-[8px]">
        <button
            v-for="(option, index) in message.options"
            :key="option.value"
            :disabled="message.optionSelected"
            type="button"
            class="flex-1 rounded-[8px] px-[14px] py-[8px] font-inter text-[13px] font-medium text-center transition-all border shadow-sm cursor-pointer"
            :class="[
                index === 0
                    ? 'bg-branding-brand-yellow border-[#E8B102] text-black hover:bg-branding-mustard'
                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300',
                message.optionSelected ? 'opacity-40 cursor-not-allowed' : '',
            ]"
            @click="selectOption(option.value, message.optionSelected)"
        >
            {{ option.label }}
        </button>
    </div>
</template>
